<app-grid-list [data]="gridData" [isEditable]="isEditable"></app-grid-list>